import { render, staticRenderFns } from "./ChevronSVG.vue?vue&type=template&id=39d68d4c&"
import script from "./ChevronSVG.vue?vue&type=script&lang=js&"
export * from "./ChevronSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports